import React, { useEffect, useState, lazy, Suspense } from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import Loader from '@components/common/Loader';
import { setSeat } from '@reducers/orders';
import { bindActionCreators } from 'redux';
import { logout } from '@reducers/oauth';
import cn from 'classnames';
import styles from './tableTop.module.scss';
import { APP_CONFIG } from '@constants';
import EventEmitter from '@utility/eventSubscribers';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { getStoreCheck } from '../../sockets/communicator';
const MultipleKeyboardInputs = lazy(() =>
  import('@components/common/MultipleInputs')
);

const TableSelection = props => {
  const [load, setLoader] = useState(false);
  useEffect(() => {
    const id = setTimeout(() => {
      if (window.ReactNativeWebView) {
        EventEmitter.enableSideBar(true);
      }
      sessionStorage.removeItem('swipeCardViewed');
      sessionStorage.removeItem('checkName');
    }, 200);

    return () => clearTimeout(id);
  }, []);

  const options = [
    {
      id: 'tableNumber',
      name: 'tableNumber',
      placeholder: CUSTOM_MESSAGES().ENTER_TABLE_NUMBER,
      type: 'text',
    },
  ];

  const initialData = {
    name: 'tableNumber',
    keyboardName: 'tableTop',
    type: 'text',
    buttonName: LABEL().ASSIGN_TABLE,
  };

  const validate = data => {
    return new Promise((resolve, reject) => {
      let error = '';
      if (isEmpty(data.tableNumber)) {
        error = 'Table Number is required';
      }
      if (isEmpty(error)) {
        resolve();
      } else {
        reject(new Error(error));
      }
    });
  };

  const onSubmit = data => {
    setLoader(true);
    getStoreCheck(props.auth.id).then(res => {
      setLoader(false);
      const checkObject = res
        ? Object.values(res).find(
            b =>
              b.open &&
              (b.stationName === data.tableNumber ||
                b.stationNumber === data.tableNumber)
          )
        : null;
      window.sessionStorage.setItem('checkName', data.tableNumber);
      props.setSeat(checkObject).then(() => {
        props.onCallBack(data);
      });
    });
  };

  const signOut = () => {
    const dataToSend = {
      latitude: '92',
      longitude: '92',
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.externalId,
      employeeCard: props.userInfo.employeeCard,
    };
    props.logout(dataToSend);
    props.history.replace(`${APP_CONFIG.BASE_URL}/checkIn?step=1`);
  };

  return (
    <div className="col-12 p-0 h-100 w-100 row mx-0 justify-content-center">
      <Suspense fallback={<Loader />}>
        {(props.loading || load) && <Loader />}
        <div
          className={cn('fs-30 px-2', styles.fixedTopRight)}
          role="presentation"
          onClick={() => signOut()}
        >
          <i className="od-text-primary fa fa-sign-out-alt" />
        </div>
        <MultipleKeyboardInputs
          inputOptions={options}
          initialData={initialData}
          containerClass="col-6"
          validate={validate}
          onSubmit={onSubmit}
          isAlpha
        />
      </Suspense>
    </div>
  );
};

const mapStateToProps = state => ({
  loading: state.oauth.loading,
  tableData: state.storeChecks.checkListHashTable,
  deviceInfo: state.oauth.deviceInformation,
  auth: state.oauth.authInfo,
  userInfo: state.oauth.loggedInUserData,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setSeat,
      logout,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(TableSelection));
